import { gql } from 'graphql-request';

export const getIncidentDetailsQuery = gql`
  query GetIncidentDetails($id: String!) {
    incident(id: $id) {
      id
      startTime
      endTime
      displayName
      message
      assignee
      status
      severity
      severityRank
      tags
      owners
      subscribers
      runFailureEventCount
      lastEventTime
      lastFailureEventTime
      tickets {
        service
        serviceTicketUrl
        serviceTicketId
      }
      summaries {
        id
        summaryType
        content
      }
      events {
        id
        eventTime
        eventType
        eventStatus
        status
        exception
        description
        failures
        data
      }
      source {
        __typename
        ... on TestIncidentSource {
          asset {
            id
            dbName
            schemaName
            name
          }
          test {
            id
            name
            type
            description
          }
          testExecution: execution {
            id
            subType
            subTestUniqueId
            columnName
          }
        }
        ... on ModelIncidentSource {
          asset {
            id
            dbName
            schemaName
            name
            description
          }
          modelExecution: execution {
            id
            status
            query
            executionTimestamp
          }
        }
        ... on PipelineIncidentSource {
          connectorName
          connectorType
          toolType
          connectorId
          destination
          rootEventId
        }
      }
    }
  }
`;
